module.exports = __webpack_public_path__ + "static/media/rocket.21868871.svg";